import { Component, WritableSignal, signal } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { LazyLoadEvent, MessageService, SortMeta } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { RapportSST } from 'src/app/entites/rapport-sst';
import { RapportSstService } from 'src/app/services/rapport-sst-service';
import { Table } from 'primeng/table';
import { Emplacement } from 'src/app/entites/emplacement';
import { AjouterRapportJournalierSstComponent } from './controles/ajouter-rapport-journalier-sst.component';
import { Statut } from 'src/app/entites/statut';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';

interface ViewOption {
  label: string;
  value: string;
}

@Component({
  selector: 'app-rapport-journalier-sst',
  templateUrl: './rapport-journalier-sst.component.html',
  providers: [DialogService]
})
export class RapportJournalierSSTComponent extends BaseComponent {

  public rapportSST: RapportSST[];

  totalRecords: number = 0;
  loading: boolean = false;
  error: string = '';

  emplacements: Emplacement[] = this.sdb.Emplacements();
  statuts: Statut[] = this.sdb.Statuts();

  showOnlyMyEmplacements: WritableSignal<boolean> = signal(true);
  tableParams = this.createTableFilter();
  globalFilter: string = '';
  sortMeta: SortMeta[] = [
    { field: 'indArchive', order: 1 },
    { field: 'date', order: -1 },
    { field: 'emplacementId', order: -1 }
  ];

  viewOptions: ViewOption[] = [
    { label: 'Table', value: 'table' },
    { label: 'Calendrier', value: 'calendar' }
  ];
  selectedView: WritableSignal<string> = this.createLocalStorageSignal('rapport-journalier-sst-view', 'table');

  constructor(
    sdb: DonneesBaseService,
    profilService: ProfilService,
    route: ActivatedRoute,
    public router: Router,
    public messageService: MessageService,
    public appMain: AppMainComponent,
    public rapportSstService: RapportSstService,
    public dialogService: DialogService,
    private breadcrumbService: BreadcrumbService
  ) {
    super(sdb, profilService, route, router, appMain);
    this.breadcrumbService.setItems([
      { label: 'Rapport SST' }
    ]);

    if (this.appMain.isMobile) {
      this.selectedView.set('table');
    }
    this.CompleterChargement();
  }

  nouveauRapportSST() {
    this.dialogService.open(AjouterRapportJournalierSstComponent, {
      header: 'Nouveau rapport SST',
      width: this.appMain.isMobile ? '100%' : '50%',
      height: this.appMain.isMobile ? '80%' : 'auto',
    });
  }

  clearFilters(table: Table) {
    table.reset();
    table.clear();
    this.globalFilter = '';
    this.sortMeta = [
      { field: 'indArchive', order: 1 },
      { field: 'date', order: -1 },
      { field: 'emplacementId', order: -1 }
    ];
  }

  chargerRapportSST(event: LazyLoadEvent) {
    this.loading = true;
    this.rapportSstService.Obtenir(event).subscribe({
      next: data => {
        this.rapportSST = data.elements;
        this.totalRecords = data.maxCount;
        this.prefetch(event);
        this.loading = false;
      },
      error: (error) => {
        this.rapportSST = [];
        this.totalRecords = 0;
        this.loading = false;
        this.error = error.error;
      }
    });
  }

  prefetch(event: LazyLoadEvent) {
    if (event.first > 0) {
      const prevEvent = { ...event, first: event.first - event.rows };
      this.rapportSstService.Obtenir(prevEvent).subscribe();
    }

    if (event.first + event.rows < this.totalRecords) {
      const nextEvent = { ...event, first: event.first + event.rows };
      this.rapportSstService.Obtenir(nextEvent).subscribe();
    }
  }
}
